exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dv-percent-pond{position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.dv-percent-pond svg{position:absolute;left:0;top:0;width:100%;height:100%}.dv-percent-pond polyline{transition:all .3s}.dv-percent-pond text{font-size:25px;font-weight:700;text-anchor:middle;dominant-baseline:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/@jiaminghi/data-view/lib/components/percentPond/src/main.css
// module id = 1101
// module chunks = 45